module.exports = __webpack_public_path__ + "img/制证女.70d56431.png";